import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  timelineOppositeContentClasses,
  TimelineSeparator,
} from '@mui/lab';
import { Paper, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { type FC } from 'react';

import { type RouterNetworkEventItem } from '@okvc/schema';

import { describeNetworkEvent } from './routerNetworkFormat.js';

interface RouterEventsTabProps {
  events: RouterNetworkEventItem[];
}

const RouterEventsTab: FC<RouterEventsTabProps> = ({ events }) => {
  if (events.length === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography color="text.secondary">No network changes recorded for this router yet.</Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined" sx={{ p: 1 }}>
      <Timeline sx={{ [`& .${timelineOppositeContentClasses.root}`]: { flex: 0.25 } }}>
        {events.map((event, index) => {
          const description = describeNetworkEvent(event);
          const happenedAt = DateTime.fromISO(event.createdAt);
          return (
            <TimelineItem key={event.id}>
              <TimelineOppositeContent color="text.secondary" variant="body2">
                <span title={happenedAt.toLocaleString(DateTime.DATETIME_FULL)}>
                  {happenedAt.toLocaleString(DateTime.DATETIME_MED)}
                </span>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot color={description.tone} />
                {index < events.length - 1 ? <TimelineConnector /> : null}
              </TimelineSeparator>
              <TimelineContent>
                <Typography variant="body1">{description.title}</Typography>
                {description.detail ? (
                  <Typography variant="body2" color="text.secondary">{description.detail}</Typography>
                ) : null}
              </TimelineContent>
            </TimelineItem>
          );
        })}
      </Timeline>
    </Paper>
  );
};

export default RouterEventsTab;
